import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/pcs-ui/src/components/AppLayoutWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/pcs-ui/src/index.css");
